module.exports = __webpack_public_path__ + "images/2d810d67e0af24b4faf11f3a4d28a4a16.png";